<form #editConsultaForm="ngForm">
    <app-custom-modal #modal [title]="'Remarcar Consulta'" [subtitle]="''" (onCloseClick)="modal.close()"
        (onSaveClick)="save()" [saveLabel]="'Remarcar →'" hideCancel [saveDisabled]="editConsultaForm.invalid">
        <div class="container">
            <div class="mb-4">
                <ng-container *ngIf="consulta.paciente && consulta.pacienteId">
                    <label for="descricao" class="form-label required">Paciente</label>
                    <div class="card mt-4 scroll-container">
                        <div class="row d-flex align-items-center">
                            <div class="col-auto">
                                <div class="user-foto-container">
                                    <img src="../../../../assets/img/user.png" alt="Foto do usuário">
                                </div>
                            </div>
                            <div class="col-auto d-flex flex-column justify-content-start p-0">
                                <p class="nome-paciente">{{consulta.paciente.nome}}</p>
                                <p class="cpf-paciente">{{consulta.paciente.cpf | cpfCnpj}}</p>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </div>
            <div class="mb-4">
                <ng-container *ngIf="consulta.profissionalSaude && consulta.profissionalId">
                    <label for="descricao" class="form-label required">Profissional da saúde</label>
                    <div class="card mt-4 scroll-container">
                        <div class="row d-flex align-items-center">
                            <div class="col-auto">
                                <div class="user-foto-container">
                                    <img src="../../../../assets/img/user.png" alt="Foto do usuário">
                                </div>
                            </div>
                            <div class="col-auto d-flex flex-column justify-content-start p-0">
                                <p class="nome-paciente">{{consulta.profissionalSaude.nome}}</p>
                                <p class="cpf-paciente">{{consulta.profissionalSaude.cpf | cpfCnpj}}</p>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </div>
            <div class="mb-4">
                <label for="convenio-selected" class="form-label required">Convênio</label>
                <select name="convenio-selected" id="convenio-selected" class="custom-select form-control"
                    [(ngModel)]="consulta.convenioId">
                    <option [value]="null">Particular</option>
                    <option *ngFor="let convenio of convenios" [value]="convenio.id">{{convenio.razaoSocial}}</option>
                </select>
            </div>
            <div class="mb-4">
                <label for="sala" class="form-label required">Sala</label>
                <select name="sala" class="form-control" id="sala" [disabled]="agendas.length == 0"
                    [(ngModel)]="consulta.agendaId" (change)="selecionarAgenda()" required>
                    <option *ngFor="let agenda of agendas" [ngValue]="agenda.id">
                        {{ agenda.nomeSala }}
                    </option>
                </select>
            </div>
            <div class="mb-4">
                <div class="input-group d-flex flex-column">
                    <label for="dataConsulta" class="form-label required">Data da consulta</label>
                    <custom-datepicker-selected #datePicker (onAlterMonth)="atualizarDatasDisponiveis($event)"
                        [dataSelecionada]="dataConsulta"
                        (onSelected)="setDataConsulta($event)"></custom-datepicker-selected>
                </div>
            </div>
            <div class="mb-4">
                <label for="horarioConsulta" class="form-label required">Horário</label>
                <select name="horarioConsulta" class="form-control" id="horarioConsulta"
                    [(ngModel)]="horarioSelecionado" (change)="setHorario()" required>
                    <option *ngFor="let horario of horariosDisponiveis" [ngValue]="horario">
                        {{ horario.horaInicio }}
                    </option>
                </select>
            </div>
        </div>
    </app-custom-modal>
</form>